import styled from 'styled-components';
import { pageContainerStyles, fullHeightPageStyles } from '../../themes/layout';

/**
 * Standard page container with consistent max-width and padding.
 * Centers content and provides responsive padding.
 */
export const PageContainer = styled.div`
  ${pageContainerStyles}
  background-color: #fff;
`;

/**
 * Full-height page container for pages that should fill the viewport.
 */
export const FullHeightPageContainer = styled.div`
  ${fullHeightPageStyles}
  background-color: #fff;
  display: flex;
  flex-direction: column;
`;

/**
 * Page wrapper that doesn't add padding but constrains width.
 * Useful for pages with full-width backgrounds that need centered content.
 */
export const PageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  background-color: #fff;
  overflow: visible;
`;

/**
 * Inner content container to be used inside PageWrapper.
 */
export const PageContent = styled.div`
  ${pageContainerStyles}
`;
